import type {
  DeviceModelOutput,
  CreateDeviceModelInput,
  UpdateDeviceModelInput,
  ImportDeviceModelsInput,
} from '@grosync/common';
import { apiRequest } from './client';

export interface ImportDeviceModelsResult {
  imported: number;
  skipped: number;
  remapped: number;
}

export const fetchDeviceModels = (): Promise<DeviceModelOutput[]> =>
  apiRequest<DeviceModelOutput[]>('/api/device-models');

export const createDeviceModel = (body: CreateDeviceModelInput): Promise<DeviceModelOutput> =>
  apiRequest<DeviceModelOutput>('/api/device-models', {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const updateDeviceModel = (
  id: string,
  body: UpdateDeviceModelInput,
): Promise<DeviceModelOutput> =>
  apiRequest<DeviceModelOutput>(`/api/device-models/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });

export const deleteDeviceModel = (id: string): Promise<void> =>
  apiRequest<void>(`/api/device-models/${id}`, { method: 'DELETE' });

export const importDeviceModels = (
  body: ImportDeviceModelsInput,
): Promise<ImportDeviceModelsResult> =>
  apiRequest<ImportDeviceModelsResult>('/api/device-models/import', {
    method: 'POST',
    body: JSON.stringify(body),
  });
